import { TextButton } from '@riac/design-system';
import styled from 'styled-components';

export const ClearFiltersText = styled.p`
  margin: 0.5em 0;
  ${TextButton}
  {
    color: ${({ theme }) => theme.black[80]}
  }
  
  svg {
    vertical-align: middle;
  }
`;
